function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import { node, string, shape } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { C_EBON, C_METAL, C_LUNAR } from '@bbc/psammead-styles/colours';
import { getBrevier } from '@bbc/gel-foundations/typography';
import { getSerifMedium } from '@bbc/psammead-styles/font-styles';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
var StyledIndexAlsos = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledIndexAlsos",
  componentId: "xsqyvb-0"
})(["position:relative;z-index:2;padding:", " 0 0;"], GEL_SPACING_DBL);
var StyledIndexAlso = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledIndexAlso",
  componentId: "xsqyvb-1"
})(["border-top:1px solid ", ";padding:", " 0;"], C_LUNAR, GEL_SPACING);
var StyledIndexAlsosUl = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledIndexAlsosUl",
  componentId: "xsqyvb-2"
})(["list-style-type:none;padding:0;margin:0;"]);
var RoleText = /*#__PURE__*/styled.span.attrs({
  role: 'text'
}).withConfig({
  displayName: "RoleText",
  componentId: "xsqyvb-3"
})([""]);
var IndexAlsosText = /*#__PURE__*/styled.span.withConfig({
  displayName: "IndexAlsosText",
  componentId: "xsqyvb-4"
})(["display:inline;vertical-align:middle;"]);
var StyledIndexAlsosLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledIndexAlsosLink",
  componentId: "xsqyvb-5"
})(["", ";", " color:", ";text-decoration:none;&:hover,&:focus{text-decoration:underline;}&:visited{color:", ";}& svg{margin:0;}"], function (_ref) {
  var script = _ref.script;
  return script && getBrevier(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSerifMedium(service);
}, C_EBON, C_METAL);

var IndexAlsosLink = function IndexAlsosLink(_ref3) {
  var children = _ref3.children,
      script = _ref3.script,
      service = _ref3.service,
      url = _ref3.url,
      mediaIndicator = _ref3.mediaIndicator,
      mediaType = _ref3.mediaType;
  return /*#__PURE__*/React.createElement(StyledIndexAlsosLink, {
    href: url,
    script: script,
    service: service
  }, mediaIndicator ? /*#__PURE__*/React.createElement(React.Fragment, null, mediaIndicator, /*#__PURE__*/React.createElement(RoleText, null, /*#__PURE__*/React.createElement(VisuallyHiddenText, null, "".concat(mediaType, ", ")), /*#__PURE__*/React.createElement(IndexAlsosText, null, children))) : /*#__PURE__*/React.createElement(IndexAlsosText, null, children));
};

IndexAlsosLink.propTypes = {
  children: node.isRequired,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  url: string.isRequired,
  mediaIndicator: node,
  mediaType: string
};
IndexAlsosLink.defaultProps = {
  mediaIndicator: null,
  mediaType: null
};
export var IndexAlsos = function IndexAlsos(props) {
  var offScreenText = props.offScreenText,
      children = props.children;
  return /*#__PURE__*/React.createElement(StyledIndexAlsos, props, /*#__PURE__*/React.createElement(VisuallyHiddenText, {
    as: "h4"
  }, offScreenText), children);
};
IndexAlsos.propTypes = {
  children: node.isRequired,
  offScreenText: string
};
IndexAlsos.defaultProps = {
  offScreenText: null
};
export var IndexAlsosUl = function IndexAlsosUl(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(StyledIndexAlsosUl, {
    role: "list"
  }, children);
};
IndexAlsosUl.propTypes = {
  children: node.isRequired
};
export var IndexAlsosLi = function IndexAlsosLi(_ref5) {
  var props = _extends({}, _ref5);

  return /*#__PURE__*/React.createElement(StyledIndexAlso, {
    as: "li",
    role: "listitem"
  }, /*#__PURE__*/React.createElement(IndexAlsosLink, props));
};
export var IndexAlso = function IndexAlso(_ref6) {
  var props = _extends({}, _ref6);

  return /*#__PURE__*/React.createElement(StyledIndexAlso, null, /*#__PURE__*/React.createElement(IndexAlsosLink, props));
};